export const STATE_GLOBAL_SECTION_SET = "stateGlobalSectionSet";

export const SET_AUTH = "setAuth";
export const SET_USER = "setUser";
export const PURGE_AUTH = "logOut";

export const SET_TAXONOMIES = "setTaxonomies";
export const SET_TARGETS = "setTargets";

export const SET_FOLDERS = "setFolders";
export const SET_CURRENT_FOLDER = "setCurrentFolder";
export const UNSET_CURRENT_FOLDER = "unsetCurrentFolder";

export const SET_NOTES = "setNotes";
export const UNSET_NOTES = "unsetNotes";
export const SET_CURRENT_NOTE = "setCurrentNote";

export const SET_ARTICLES = "setArticles";
export const PURGE_ARTICLES = "unsetArticles";
export const UPDATE_ARTICLES = "updateArticles";
export const SET_FILTERS = "setFilters";
export const UPDATE_FILTERED_ARTICLES = "updateFilteredArticles";
export const SET_CURRENT_ARTICLE = "setCurrentArticle";
export const SET_ARTICLE_VISITED = "setArticleVisited";
export const SET_ARTICLE_OPENED = "setArticleOpened";
export const SET_ARTICLE_SAVED = "setArticleSaved";

export const SET_SEARCH_ENGINE = "setSearchEngine";
export const SET_SEARCH_QUERY = "setSearchQuery";
export const SET_SEARCH_BY_FILE = "setSearchByFile";
export const PURGE_SEARCH = "unsetSearch";

export const SET_SUBNOTES = "setSubnotes";
export const PURGE_SUBNOTES = "unsetSubnotes";
export const DELETE_SUBNOTE = "deleteSubnote";

export const ADD_FOLDER = "addFolder";
export const ADD_NOTE = "addNote";

export const STATE_MONITORS_TAGS_SET                  = "stateMonitorsTagsSet";
export const STATE_MONITORS_CONSUMER_INSIGHTS_SET     = "stateMonitorsConsumerInsightsSet";
export const STATE_MONITORS_CONSUMER_GENERATIONS_SET  = "stateMonitorsConsumerGenerationsSet";
export const STATE_MONITORS_MARKET_INSIGHTS_SET       = "stateMonitorsMarketInsightsSet";
export const STATE_MONITORS_MARKET_SECTORS_SET        = "stateMonitorsMarketSectorsSet";
export const STATE_MONITORS_GEOLOCALIZATION_SET       = "stateMonitorsGeolocalizationSet";
export const STATE_MONITORS_GENDER_SET                = "stateMonitorsGenderSet";

export const STATE_MONITORS_CUSTOMERS_SET           = "stateMonitorsCustomersSet";
export const STATE_MONITORS_MARKETS_SET             = "stateMonitorsMarketsSet";
export const STATE_MONITORS_SET                     = "stateMonitorsSet";
export const STATE_MONITORS_SET_LIST_CONSUMER       = "stateMonitorsSetListConsumer";
export const STATE_MONITORS_SET_LIST_MARKET         = "stateMonitorsSetListMarket";
export const STATE_MONITORS_CURRENT_CATEGORY_SET    = "stateMonitorsCurrentCategorySet";
export const STATE_MONITORS_CURRENT_TAG_SET         = "stateMonitorsCurrentTagSet";
export const STATE_MONITORS_CURRENT_SET             = "stateMonitorsCurrentSet";
export const STATE_MONITORS_CURRENT_CHAPTERS_SET    = "stateMonitorsCurrentChaptersSet";
export const STATE_MONITORS_CURRENT_CHAPTER_SET     = "stateMonitorsCurrentChapterSet";
export const STATE_MONITORS_CURRENT_PARAGRAPHS_SET  = "stateMonitorsCurrentParagraphsSet";
export const STATE_MONITORS_CURRENT_PARAGRAPH_SET   = "stateMonitorsCurrentParagraphSet";

export const STATE_MONITORS_STRUCTURE_CHAPTERS_SET          = "stateMonitorsStructureChaptersSet";
export const STATE_MONITORS_STRUCTURE_CHAPTERS_ORDER_SET    = "stateMonitorsStructureChaptersOrderSet";
export const STATE_MONITORS_STRUCTURE_PARAGRAPHS_SET        = "stateMonitorsStructureParagraphsSet";

export const STATE_MONITORS_RECENT_TARGETS_SET           = "stateMonitorsRecentTargetsSet";
export const STATE_MONITORS_RECENT_TAXONOMIES_SET        = "stateMonitorsRecentTaxonomiesSet";